export default __webpack_public_path__ + "ffdfd83002530e747b882c4bfccbc577.png";